import React from 'react';
export const defaultState = {
    shiftId: '',
    shiftStartTime: 0,
    shiftStopTime: 0,
    participantIds: [],
};
/**
 * This context is used to refetch participants to accurately display their availability in different shifts with overlapping times of the same mission.
 */
export const ParticipantsAvailabilityContext = React.createContext({
    isParticipantAvailabilityPotentiallyChanged: () => false,
    setLastModifiedShiftParticipants: () => { },
});
export const ParticipantsAvailabilityProvider = ({ children }) => {
    const [lastModifiedShiftParticipants, setLastModifiedShiftParticipants] = React.useState(defaultState);
    const isParticipantAvailabilityPotentiallyChanged = React.useCallback(({ shiftId, shiftStartTime, shiftStopTime, participantIds }) => lastModifiedShiftParticipants.shiftId !== shiftId &&
        lastModifiedShiftParticipants.shiftStopTime > shiftStartTime &&
        lastModifiedShiftParticipants.shiftStartTime < shiftStopTime &&
        participantIds.some((id) => lastModifiedShiftParticipants.participantIds.includes(id)), [lastModifiedShiftParticipants]);
    return (React.createElement(ParticipantsAvailabilityContext.Provider, { value: { isParticipantAvailabilityPotentiallyChanged, setLastModifiedShiftParticipants } }, children));
};
